import { AppCalendarHeaderComponent } from './app-calendar-header/app-calendar-header.component';
import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-calendar',
  templateUrl: './app-calendar.component.html',
  styleUrls: ['./app-calendar.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppCalendarComponent implements OnInit {
  [x: string]: any;

  calendarHeader = AppCalendarHeaderComponent;

  @Input()
  set selectedDate(date: Date) {
    this.date.setValue(date);
  }

  @Input()
  maxDate!: Date;

  @Input()
  minDate!: Date;

  @Input()
  readOnly: boolean = true;

  @Output()
  dateChanged: EventEmitter<Date> = new EventEmitter<Date>();

  date: FormControl = new FormControl(new Date());

  constructor() { }

  ngOnInit(): void {
  }

  changeDate(): void {
    this.dateChanged.emit(new Date(this.date.value));
  }

}
